// extracted by mini-css-extract-plugin
export default {"l_Hr_main":"Hr_l_Hr_main__OZG3d"};